<template>
  <div id="fillCardNumber">
    <Input
      :placeholder="placeholder"
      v-model="bankCard"
      class="cardNumber"
      :reg="[
        {
          pattern: /^[0-9]{8,30}$/,
          message: '请输入正确的银行卡号',
        },
      ]"
      type="tel"
      :maxlength="30"
      :label="label"
    />
    <div class="tip">
      <p>1.此账号将作为提款和还款账号！如未办理，请到网点办理浦发借记卡。</p>
      <p style="color: #ff6538">2.确保银行卡预留手机号与借款人手机号保持一致，当日新办借记卡若提示“四要素验证不通过”请次日办理。</p>
    </div>
    <!-- <Contract
      :list="contractList"
      v-model="agreeState"
      :defaultCheck="false"
    /> -->
    <div class="bottomButton">
      <Button
        :text="draw"
        :type="danger"
        class="next"
        :disabled="canGoNext"
        :click="goToNextPage"
      />
      <div class="nextStep">
        <div
          class="goCard"
          @click="goCard"
        >无卡？去开卡</div>
      </div>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { Toast } from 'vant';
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import Contract from '@/components/Contract.vue';
import ServerBank from '@/components/ServerBank.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'fillCardNumber',
  data() {
    return {
      bankCard: '',
      danger: 'danger',
      draw: '下一步',
      agreeState: true,
      contractList: [
        {
          text: '个人信息查询和提供在线授权书',
          value: 'spdb_pi',
        },
      ],
      placeholder: '请填写浦发银行借记卡号',
      label: '银行卡号',
      orderId:
        this.$router.currentRoute.query.orderId
        || localStorage.getItem('orderId'),
    };
  },
  components: {
    Button,
    Input,
    Contract,
    ServerBank
  },
  mounted() {
    this.loadGetBankInfo();
  },
  computed: {
    canGoNext() {
      const reg = /^[0-9]{8,30}$/;
      return !reg.test(this.bankCard) || !this.agreeState;
    },
  },
  watch: {
    bankCard: {
      handler(newVal) {
        this.updateForm({
          bankCard: newVal,
        });
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('otherPages', ['updateForm']),
    ...mapActions('otherPages', ['addFillCardNumber']),
    goToNextPage() {
      this.addFillCardNumber({ orderId: this.orderId });
    },
    // 回显银行卡信息
    loadGetBankInfo() {
      const { getBankInfo } = this.$api.CommonForms;
      getBankInfo({ orderId: this.orderId }).then((res) => {
        if (res && res.success) {
          const { bankCard } = res.data;
          this.updateForm({
            bankCard,
          });
          this.bankCard = bankCard;
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    goCard() {
      // 只有浦发必须勾选协议才能开卡
      // if(this.$route.query.productId === 'SPDB-FPD' && !this.agreeState) {
      //   Toast('请先阅读并同意协议');
      //   return;
      // }
      /**
       * 0 -- > SUCCESSSTATUS
       * 1 -- > failStatus
       * 2 -- > defaultStatus
       * "0:成功或失败 1:处理中提示 2:原有跳转逻辑"
      */
      const SUCCESSSTATUS = '0';
      const FAILSTATUS = '1';
      const DEFAULTSTATUS = '2';
      this.$api.OtherPage.getProgressAccount({ orderId: this.orderId }).then((res) => {
        if (res.success) {
          if (res.data.status === SUCCESSSTATUS) {
            this.$dialog.confirm({
              title: '提示',
              message: res.data.msg,
              confirmButtonText: '继续',
              cancelButtonText: '取消',
            }).then(() => {
              localStorage.setItem('orderId', this.orderId);
              this.$router.push(
                `/supermarket/v2/UploadIdentity?orderId=${this.orderId}`,
              );
            })
              .finally(() => {
                this.loadGetBankInfo();
              });
          } else if (res.data.status === FAILSTATUS) {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg,
              confirmButtonText: '确定',
            }).finally(() => {
              this.loadGetBankInfo();
            });
          } else if (res.data.status === DEFAULTSTATUS) {
            localStorage.setItem('orderId', this.orderId);
            this.$router.push(
              `/supermarket/v2/UploadIdentity?orderId=${this.orderId}`,
            );
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>
<style scoped>
#fillCardNumber {
  width: 100%;
  height: 100%;
  background: #fff;
}
.tip {
  box-sizing: border-box;
  padding-right: 20px;
  padding-left: 20px;
  color: rgba(128, 128, 128, 1);
  font-size: 13px;
  text-align: left;
}
.nextStep {
  margin: 20px 15px 0 15px;
}
.next {
  margin: 100px 0 0 0;
}
.cardNumber {
  letter-spacing: 2px;
  line-height: 28px;
}
.goCard {
  height: 44px;
  text-align: center;
  line-height: 44px;
  border-radius: 8px;
  color: #f65249;
  font-size: 17px;
  font-family: PingFangSC-Regular;
  border: 1px solid #ff6538;
}
</style>
